;(function () {
  'use strict'

  angular
    .module('contrast.modal-protect-apps-tip')
    .controller('ModalProtectAppsTipCtrl', [
      '$uibModalInstance',
      ModalProtectAppsTipCtrl
    ])

  function ModalProtectAppsTipCtrl($uibModalInstance) {
    var vm = this

    angular.extend(vm, {
      cancel: cancel,
      close: close
    })

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }

    function close() {
      $uibModalInstance.close()
    }
  }
})()
